import React, { useEffect, useState } from 'react';
import Navbar from './../Navbar/Navbar';
import CategoriesSection from '../Categories/CategoriesSection';
import hero from "../../imgs/hero2.png";
import Header from './../Header/Header';
import TrainerCard from './../../Shared components/TrainerCard';
import { FiArrowLeft, FiArrowRight } from "react-icons/fi";
import Footer from './../Footer/Footer';
import axios from 'axios';
import { Config } from '../../API/config';
import SkeletonCard from '../../Shared components/SkeletonCard';
import { TrainerData } from '../../types/TrainerInfo';
import { Filters } from '../../types/filter';
import toast, { Toaster } from 'react-hot-toast';
import SearchBarWithFilters from '../../Shared components/SearchBarWithFilters';
import { Link } from 'react-router-dom';
import { FaWhatsapp } from 'react-icons/fa';

const trainersPerPage = 6;
const defaultFilters: Filters = {
    price: [0, 1000],
    rate: 0,
    numOfOrders: 0,
    category: "",
    subCategory: "",
    name: "",
};

const Home = () => {
    const [trainers, setTrainers] = useState<TrainerData[]>([]);
    const [trainersByRate, setTrainersByRate] = useState<TrainerData[]>([]);
    const [trainersByNumOfOrders, setTrainersByNumOfOrders] = useState<TrainerData[]>([]);
    const [filters, setFilters] = useState<Filters>(defaultFilters);
    const [nameQuery, setNameQuery] = useState<string>("");
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const [isLoading, setIsLoading] = useState(true);

    // Separate pagination states with max pages
    const [page, setPage] = useState(1);
    const [ratePage, setRatePage] = useState(1);
    const [ordersPage, setOrdersPage] = useState(1);
    const [maxPage, setMaxPage] = useState(1);

    // Pagination handlers with max page checks
    const nextPage = () => setPage((prev) => Math.min(prev + 1, maxPage));
    const prevPage = () => setPage((prev) => Math.max(prev - 1, 1));
    const nextRatePage = () => setRatePage((prev) => Math.min(prev + 1, maxPage));
    const prevRatePage = () => setRatePage((prev) => Math.max(prev - 1, 1));
    const nextOrdersPage = () => setOrdersPage((prev) => Math.min(prev + 1, maxPage));
    const prevOrdersPage = () => setOrdersPage((prev) => Math.max(prev - 1, 1));

    const handleLoading = (loading: boolean) => {
        setIsLoading(loading);
    };

    const fetchFilteredTrainers = async () => {
        try {

            setIsFilterLoading(true);
            const params = new URLSearchParams();

            Object.entries(filters).forEach(([key, value]) => {
                if (value !== undefined && value !== "" && value !== null && value) {
                    if (Array.isArray(value)) {
                        if (key === "price") {
                            params.append(key, value[1].toString());
                        } else {
                            params.append(key, value[0].toString());
                        }
                    } else {
                        params.append(key, value.toString());
                    }
                }
            });

            params.append("limit", trainersPerPage.toString());
            params.append("page", page.toString());

            let { data } = await axios.get(`${Config.getAllTrainers}?${params.toString()}`, { withCredentials: true });



            if (data.statusCode === 200) {
                setTrainers(data.data.trainers);
                setMaxPage(Math.ceil(data.data.numOfTrainers / trainersPerPage));
            }
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status === 404) {
                toast.error("لا يوجد");
                if (page > 1) setPage((prev) => prev - 1);
                else if (page === 1 && (filters.category || filters.subCategory)) {
                    setFilters({ ...filters, category: "", subCategory: "" });
                }
            } else {
                toast.error("حدث خطأ حاول في وقت لاحق");
                if (page > 1) setPage((prev) => prev - 1);
            }
        } finally {
            setIsFilterLoading(false);
        }
    };

    const fetchAHighRatedTrainers = async () => {
        try {
            const params = new URLSearchParams();
            params.append("limit", trainersPerPage.toString());
            params.append("page", ratePage.toString());

            let { data } = await axios.get(`${Config.getTrainersSortedByRate}?${params.toString()}`, { withCredentials: true });

            if (data.statusCode === 200) {
                setTrainersByRate(data.data.trainers || data.data); // Adjust based on API response structure
            }
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status === 404) {
                toast.error("لا يوجد صفحة أخرى");
                if (ratePage > 1) setRatePage((prev) => prev - 1);
            } else {
                toast.error("حدث خطأ حاول في وقت لاحق");
                if (ratePage > 1) setRatePage((prev) => prev - 1);
            }
        }
    };

    const fetchTrainersSortedByNumOfOrders = async () => {
        try {
            const params = new URLSearchParams();
            params.append("limit", trainersPerPage.toString());
            params.append("page", ordersPage.toString());

            let { data } = await axios.get(`${Config.getTrainersSortedByNumOfOrders}?${params.toString()}`, { withCredentials: true });

            if (data.statusCode === 200) {
                setTrainersByNumOfOrders(data.data.trainers || data.data);
            }
        } catch (err) {
            if (axios.isAxiosError(err) && err.response?.status === 404) {
                toast.error("لا يوجد صفحة أخرى");
                if (ordersPage > 1) setOrdersPage((prev) => prev - 1);
            } else {
                toast.error("حدث خطأ حاول في وقت لاحق");
                if (ordersPage > 1) setOrdersPage((prev) => prev - 1);
            }
        }
    };

    useEffect(() => {
        fetchFilteredTrainers();
    }, [filters, page]);

    useEffect(() => {
        fetchAHighRatedTrainers();
    }, [ratePage]);

    useEffect(() => {
        fetchTrainersSortedByNumOfOrders();
    }, [ordersPage]);

    const handleApplyFilters = (appliedFilters: Filters) => {
        setPage(1);
        if (appliedFilters.name) setNameQuery(appliedFilters.name);

        const updatedFilters: Partial<Filters> = {};
        if (appliedFilters.price &&
            (appliedFilters.price[0] !== defaultFilters.price[0] ||
                appliedFilters.price[1] !== defaultFilters.price[1])) {
            updatedFilters.price = appliedFilters.price;
        }
        if (appliedFilters.rate !== undefined && appliedFilters.rate !== defaultFilters.rate) {
            updatedFilters.rate = appliedFilters.rate;
        }
        if (appliedFilters.numOfOrders !== undefined && appliedFilters.numOfOrders !== defaultFilters.numOfOrders) {
            updatedFilters.numOfOrders = appliedFilters.numOfOrders;
        }
        if (appliedFilters.category !== undefined) {
            updatedFilters.category = appliedFilters.category;
        }
        if (appliedFilters.subCategory !== undefined) {
            updatedFilters.subCategory = appliedFilters.subCategory;
        }
        if (appliedFilters.name !== undefined && appliedFilters.name !== defaultFilters.name) {
            updatedFilters.name = appliedFilters.name;
        }

        setFilters((prevFilters) => ({
            ...prevFilters,
            ...updatedFilters,
        }));
    };

    const resetFilters = () => {
        setFilters(defaultFilters);
    };

    const resetSpecificFilter = (field: string) => {

        let updatedFilters: Filters = { ...filters };
        if (field === 'category') {
            updatedFilters = { ...updatedFilters, category: "", subCategory: "" };
        } else {
            updatedFilters.subCategory = "";
        }
        handleApplyFilters(updatedFilters);
    };

    return (
        <>
            <Toaster />
            <div>
                <Header handleLoading={handleLoading} onChange={handleApplyFilters} filters={filters} />
                {isLoading ? (
                    <SkeletonCard />
                ) : (
                    <div>
                        <a
                            target="_blank"
                            href="https://wa.me/+201040907137"
                            className="fixed right-4 bottom-10 text-white hover:text-primary-400 text-3xl z-50 bg-green-500 p-2 rounded-full" rel="noreferrer"
                        >
                            <FaWhatsapp />
                        </a>
                        <div className="mx-4 md:mx-10 lg:mx-20">
                            <section className="bg-white">
                                <div className="grid max-w-screen-xl px-4 py-8 mx-auto gap-8 lg:gap-16 lg:py-16 lg:grid-cols-12">
                                    <div className="hidden lg:flex lg:col-span-5">
                                        <img src={hero} alt="mockup" className="object-contain w-full h-auto" />
                                    </div>
                                    <div className="lg:col-span-7 text-right flex flex-col justify-center space-y-4">
                                        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-medium text-neutral-900 leading-relaxed">
                                            عايز مدرب خصوصي يخليك تتقن اي مهارة .. اطلب كوتش
                                        </h2>
                                        <p className="text-gray-500 font-light text-sm sm:text-base lg:text-lg leading-relaxed text-right">
                                            <span className="block">.لو عايز تتعلم حرفة تجيب لك فلوس او عايز تتعلم مهارة تساعدك في شغلك .. اطلب كوتش</span>
                                            <span className="block">.نفسك تتقن رياضه بسرعه و بطريق مختصر .. اطلب كوتش</span>
                                            <span className="block">.اطلب كوتش هو طريقك السهل لاحتراف اي مجال</span>
                                        </p>
                                        <div className="flex flex-col sm:flex-row gap-4">
                                            <a
                                                href="#"
                                                className="inline-flex items-center justify-center px-5 py-3 text-base font-medium text-white rounded-lg bg-primary-700 hover:bg-primary-800 focus:ring-4 focus:ring-primary-300"
                                            >
                                                Get started
                                                <svg
                                                    className="w-5 h-5 ml-2 -mr-1"
                                                    fill="currentColor"
                                                    viewBox="0 0 20 20"
                                                >
                                                    <path
                                                        fillRule="evenodd"
                                                        d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                                                        clipRule="evenodd"
                                                    ></path>
                                                </svg>
                                            </a>
                                            <div className="md:w-1/2">
                                                <Link to="/about-us">
                                                    <button className="text-white p-2 w-full border rounded-md bg-primary-300 hover:text-primary-300 hover:bg-white hover:border-primary-300 transition-all duration-500">
                                                        المزيد
                                                    </button>
                                                </Link>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </section>

                            <div className="mb-10">
                                <div className="flex items-center justify-between w-full mb-7">
                                    <div>
                                        <SearchBarWithFilters onChange={handleApplyFilters} filter={filters} />
                                    </div>
                                    <h3 className="text-2xl sm:text-3xl font-medium text-neutral-900 flex-grow text-center">
                                        مدربين حسب بحثك
                                    </h3>
                                    <button
                                        onClick={resetFilters}
                                        className="bg-red-500 hover:bg-red-600 text-white font-medium px-4 py-2 rounded-xl transition-all"
                                    >
                                        إزاله الفلاتر
                                    </button>
                                </div>

                                <div className="flex items-center justify-between mb-4">
                                    <div className="flex-grow text-center">
                                        <h3
                                            className="text-base sm:text-lg md:text-xl font-medium text-neutral-900 flex flex-wrap items-center justify-center gap-2 text-right min-h-[40px]"
                                            dir="rtl"
                                        >
                                            <span className="whitespace-nowrap">نتائج البحث عن :</span>
                                            {filters.category && (
                                                <button
                                                    onClick={() => resetSpecificFilter('category')}
                                                    className="bg-blue-100 hover:bg-blue-200 text-blue-800 font-medium px-2 py-1 sm:px-3 sm:py-1 rounded-full transition-all flex items-center"
                                                >
                                                    {filters.category} <span className="mr-1 sm:ml-1">×</span>
                                                </button>
                                            )}
                                            {filters.subCategory && (
                                                <button
                                                    onClick={() => resetSpecificFilter('subCategory')}
                                                    className="bg-green-100 hover:bg-green-200 text-green-800 font-medium px-2 py-1 sm:px-3 sm:py-1 rounded-full transition-all flex items-center"
                                                >
                                                    {filters.subCategory} <span className="mr-1 sm:ml-1">×</span>
                                                </button>
                                            )}
                                            {!filters.category && !filters.subCategory && (
                                                <span className="text-neutral-500 whitespace-nowrap">كل الفئات</span>
                                            )}
                                        </h3>
                                    </div>
                                </div>

                                <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4">
                                    {isFilterLoading ? (
                                        [...Array(trainersPerPage)].map((_, index) => (
                                            <div
                                                key={index}
                                                className="w-72 h-40 bg-gray-200 animate-pulse rounded-lg"
                                            ></div>
                                        ))
                                    ) : (
                                        trainers.map((trainer) => (
                                            <TrainerCard key={trainer._id} Trainer={trainer} />
                                        ))
                                    )}
                                </div>

                                <div className="flex items-center justify-center mt-4 gap-4">
                                    <button
                                        onClick={prevPage}
                                        disabled={page === 1}
                                        className={`flex items-center gap-2 text-black hover:text-primary-700 font-medium border px-4 py-2 rounded-xl 
                                        ${page === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    >
                                        <FiArrowLeft className="text-sm" /> السابق
                                    </button>
                                    <span className="text-lg font-semibold">صفحة {page} من {maxPage}</span>
                                    <button
                                        onClick={nextPage}
                                        disabled={page === maxPage}
                                        className={`flex items-center gap-2 text-black hover:text-primary-700 font-medium border px-4 py-2 rounded-xl 
                                        ${page === maxPage ? "opacity-50 cursor-not-allowed" : ""}`}
                                    >
                                        التالي <FiArrowRight className="text-sm" />
                                    </button>
                                </div>
                            </div>

                            <div className="mb-10">
                                <CategoriesSection />
                            </div>

                            <div className="mb-10">
                                <h3 className="text-2xl sm:text-3xl font-medium text-center text-neutral-900 mb-4">
                                    الاعلي تقييم
                                </h3>
                                <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4">
                                    {trainersByRate.map((trainer) => (
                                        <TrainerCard key={trainer._id} Trainer={trainer} />
                                    ))}
                                </div>
                                <div className="flex items-center justify-center mt-4 gap-4">
                                    <button
                                        onClick={prevRatePage}
                                        disabled={ratePage === 1}
                                        className={`flex items-center gap-2 text-black hover:text-primary-700 font-medium border px-4 py-2 rounded-xl 
                                        ${ratePage === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                    >
                                        <FiArrowLeft className="text-sm" /> السابق
                                    </button>
                                    <span className="text-lg font-semibold">صفحة {ratePage} من {maxPage}</span>
                                    <button
                                        onClick={nextRatePage}
                                        disabled={ratePage === maxPage}
                                        className={`flex items-center gap-2 text-black hover:text-primary-700 font-medium border px-4 py-2 rounded-xl 
                                        ${ratePage === maxPage ? "opacity-50 cursor-not-allowed" : ""}`}
                                    >
                                        التالي <FiArrowRight className="text-sm" />
                                    </button>
                                </div>
                            </div>

                            <div className="mb-10">
                                <h3 className="text-2xl sm:text-3xl font-medium text-center text-neutral-900 mb-4">
                                    الاكثر طلبا
                                </h3>
                                {trainersByNumOfOrders.length ? (
                                    <>
                                        <div className="flex flex-col md:flex-row flex-wrap justify-center gap-4">
                                            {trainersByNumOfOrders.map((trainer) => (
                                                <TrainerCard key={trainer._id} Trainer={trainer} />
                                            ))}
                                        </div>
                                        <div className="flex items-center justify-center mt-4 gap-4">
                                            <button
                                                onClick={prevOrdersPage}
                                                disabled={ordersPage === 1}
                                                className={`flex items-center gap-2 text-black hover:text-primary-700 font-medium border px-4 py-2 rounded-xl 
                                                ${ordersPage === 1 ? "opacity-50 cursor-not-allowed" : ""}`}
                                            >
                                                <FiArrowLeft className="text-sm" /> السابق
                                            </button>
                                            <span className="text-lg font-semibold">صفحة {ordersPage} من {maxPage}</span>
                                            <button
                                                onClick={nextOrdersPage}
                                                disabled={ordersPage === maxPage}
                                                className={`flex items-center gap-2 text-black hover:text-primary-700 font-medium border px-4 py-2 rounded-xl 
                                                ${ordersPage === maxPage ? "opacity-50 cursor-not-allowed" : ""}`}
                                            >
                                                التالي <FiArrowRight className="text-sm" />
                                            </button>
                                        </div>
                                    </>
                                ) : (
                                    <p className="flex flex-row items-center justify-center text-2xl">
                                        لا يوجد في الوقت الحالي
                                    </p>
                                )}
                            </div>
                        </div>
                        <Footer />
                    </div>
                )}
            </div>
        </>
    );
};

export default Home;